import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'smartTitleCase',
  pure: true
})
export class SmartTitleCasePipe implements PipeTransform {
  transform(value: string | null | undefined, onlyFirstWord = false): string {
    if (!value) return '';

    const delimiters = [' ', '-'];

    const capitalize = (word: string): string => {
      if (word.length === 0) return word;
      if (word === word.toUpperCase()) return word; // déjà en majuscules
      return word[0].toUpperCase() + word.slice(1);
    };

    const smartCapitalizeWord = (word: string, depth = 0): string => {
      if (depth >= delimiters.length) return capitalize(word);

      const delimiter = delimiters[depth];
      if (!word.includes(delimiter))
        return smartCapitalizeWord(word, depth + 1);

      return word
        .split(delimiter)
        .map(part => smartCapitalizeWord(part, depth + 1))
        .join(delimiter);
    };

    if (!onlyFirstWord) {
      return value
        .split(' ')
        .map(word => smartCapitalizeWord(word))
        .join(' ');
    }

    return value
      .split(' ')
      .map((word, index) => (index === 0 ? smartCapitalizeWord(word) : word))
      .join(' ');
  }
}
